import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";
import "./Notifications.css";
import NotificationService from "../../services/NotificationService";
import { Redirect } from "react-router-dom";

import { format } from "date-fns";
import Avatar from "react-avatar";
import { storeInEncLocalStorage } from "../../helpers/Utils/Utils";




function Notifications(props) {
 
  const [notificationList, setNotifications] = useState([]);
  const [details, showDetail] = useState(false);
  const [isAllRead, setIsAllRead] = useState();
  const [id, setDetail] = useState();
  const [isKnowledge, setKnowledge] = useState();
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  // const [progress, setProgress] = useState(0)
  

  useEffect(() => {
    getAllNotifications(1);
  }, []);

  const getAllNotifications = async (pageNum) => {
    // setLoading(true);

    let reqBody = {
      pageNo: pageNum,
      pageSize: 15,
    };
    const res = await NotificationService.getNotifications(reqBody);
    let resp = res.notificationData;
    if (resp && resp.length > 0) {
      props.setCount(res.unread_count);
      if (pageNum > 1) {
        let allNotifications = [...notificationList, ...resp];
        setNotifications(allNotifications);
      } else if (pageNum == 1) {
        let total = Math.ceil(res.total_count);
        setTotalPages(total);
        setNotifications(resp);
        setIsAllRead(resp[0].is_read);
      }
    }
    showDetail(false);
    // setLoading(false);
  };

  const markRead = async (isAll, notificationId, refId, isKnowledge) => {
    let reqBody = {};
    if (!isAll) {
      setDetail(refId);
      setKnowledge(isKnowledge);

      reqBody = {
        id: notificationId,
      };
    }
    //setPage(1);
    const resp = await NotificationService.readNotifications(reqBody);
    if (resp) {
      getAllNotifications(1);
      if (!isAll) {
        showDetail(true);
      }
    }
  };

  if (details) {

    const detailsData={ id: id, isKnowledge: isKnowledge, redirected: false }
    
    storeInEncLocalStorage("knowledgeDetailsData", JSON.stringify(detailsData))
    return (
      <Redirect
        to={{
          pathname: "/details",
          state: detailsData,
        }}
      />
    );
  }

  return (
    <div>
      {notificationList.length > 0 && (
        <div className="display-col">
          
          <div className="card">
            {!isAllRead ? (
              <p onClick={() => markRead(true)} className="mark-read">
                Mark all as read
              </p>
            ) : (
              <p className="mark-read-disabled"> Mark all as read</p>
            )}
          </div>
          <div style={{ marginTop: "10px" }}>
            {notificationList.map((item) => {
              return (
                <div
                  key={item.id}
                  className="notification-card"
                  data-bs-dismiss="offcanvas"
                  onClick={() => {
                    markRead(false, item.id, item.ref_id, item.isKnowledge);
                  }}
                >
                  <div className={item.is_read ? "card" : "unread-card card"}>
                    <div className="display-row">
                      {item.profile !== null && (
                        <Avatar
                          name={
                            item.profile.firstname + " " + item.profile.lastname
                          }
                          size="35px"
                          round={true}
                        />
                      )}
                      <div style={{ marginLeft: "10px" }}>
                        <p>{item.message}</p>
                        <small style={{ margin: "auto 0" }}>
                          {format(
                            new Date(item.created_date),
                            "MMMM dd, yyyy HH:mm"
                          )}
                        </small>
                      </div>
                    </div>
                  </div>
                  {item.is_read ? <hr /> : null}
                </div>
              );
            })}
          </div>
          <button
            className="btn btn-danger"
            onClick={() => {
              getAllNotifications(page + 1);
              setPage(page + 1);
            }}
            disabled={page + 1 > totalPages}
          >
            View more
          </button>
        </div>
      )}
    </div>
  );
}

export default Notifications;

Notifications.propTypes = {
  location: PropTypes.object,
  setCount: PropTypes.func,
};
